import { render, staticRenderFns } from "./BeCuponCardCuponInfo.vue?vue&type=template&id=e8e21db4&scoped=true&"
import script from "./BeCuponCardCuponInfo.vue?vue&type=script&lang=js&"
export * from "./BeCuponCardCuponInfo.vue?vue&type=script&lang=js&"
import style0 from "./BeCuponCardCuponInfo.vue?vue&type=style&index=0&id=e8e21db4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8e21db4",
  null
  
)

export default component.exports